
import { Component, Vue, Prop } from "vue-property-decorator";
import { SMUser } from "@/store";
import HelloWidgetTemplate from "@/components/Widgets/Templates/HelloWidgetTemplate.vue";
import Image from "@/assets/images/people/person-1.png";

const AFTER_COS_LOADED_LABEL = "after_cos";
const WHILE_COS_LOADED_LABEL = "while_cos";

@Component({
  components: {
    HelloWidgetTemplate,
  },
})
export default class Hello extends Vue {
  @Prop({ type: String }) readonly jobTitle?: string;
  @Prop({ type: String }) readonly name?: string;
  @Prop({ type: String }) readonly caseType?: string;
  @Prop({ type: String }) readonly listType?: string;
  @Prop({ type: Boolean, default: false }) readonly cosIsLoaded?: boolean;
  @Prop({ type: Boolean, default: false }) readonly paymentIsCompleted?: boolean;

  get computedProps() {
    const { jobTitle, name, list, listType, tasksEnable } = this;

    return {
      title: this.$tc("title"),
      jobTitle,
      name,
      list,
      listType,
      tasksEnable,
      image: Image,
    };
  }

  get cosLoadedStatus() {
    // DEV-8941. @Evgenii new requirement, "paymentIsCompleted" appended.
    return this.cosIsLoaded && this.paymentIsCompleted
      ? AFTER_COS_LOADED_LABEL
      : WHILE_COS_LOADED_LABEL;
  }

  get list() {
    const { caseType, cosLoadedStatus } = this;
    const role = SMUser.user?.role;

    if (!role) return [];

    const path = `list.${caseType}.${cosLoadedStatus}.${role}`;

    return this.$t(path) || [];
  }

  get tasksEnable() {
    if (SMUser.isEmployer) return true;

    return this.cosIsLoaded;
  }
}
